<template>
  <b-container id="app" fluid class="d-flex w-100">
    <b-row :class="{ 'h-100': !mixinEnvironnement_inEditor }">
      <div class="w-100 d-flex flex-column">
        <header>
          <BandeauNavigateurNonSupporte v-if="!mixinEnvironnement_isNavigateurSupporte" />
          <Navigation />
        </header>
        <div
          v-if="mixinEnvironnement_isNavigateurSupporte && $route.fullPath.indexOf('casino') > -1"
          class="app_contenu"
          :class="{ 'h-100': !mixinEnvironnement_inEditor }"
        >
          <keep-alive>
            <router-view :key="$route.path + $route.query"></router-view>
          </keep-alive>
        </div>
        <div
          v-else-if="
            mixinEnvironnement_isNavigateurSupporte && $route.fullPath.indexOf('casino') == -1
          "
          class="app_contenu"
          :class="{ 'h-100': !mixinEnvironnement_inEditor }"
        >
          <router-view :key="$route.path + $route.query"></router-view>
        </div>
      </div>
    </b-row>
  </b-container>
</template>

<script>
import { mixinEnvironnement } from '@/mixins/mixinEnvironnement';
import { registerVendorListenerConsent } from '@/helpers/ConsentHelpers';

import BandeauNavigateurNonSupporte from '@/components/base/bandeau/BandeauNavigateurNonSupporte';
import Navigation from '@/components/Navigation';

import store from '@/store';
import { isPreferencesPath } from '@/helpers/RouteHelpers';
import session from '@/services/api/compte/session';

export default {
  name: 'app',
  components: {
    BandeauNavigateurNonSupporte,
    Navigation,
  },
  mixins: [mixinEnvironnement],
  props: {
    firstLoadPage: { type: Boolean, required: false },
  },
  mounted() {
    // Indicateur de chargement app-vue !important pour réduire le nombre d'appels à loginNav
    this.$root.$data.fistloadPage = true;
    registerVendorListenerConsent(
      process.env.VUE_APP_IAB_ID_PREFERENCE,
      function () {
        store.commit('consentement/SET_CONSENTEMENT', 'preferences');
        if (session.sessionEstOuverte() && isPreferencesPath(window.location.pathname)) {
          store.dispatch('preferences/getPreferences');
        }
      },
      function () {
        store.commit('consentement/RESET_CONSENTEMENT', 'preferences');
      }
    );
  },
};
</script>

<style lang="scss">
@import './App.scss';
</style>
